import HeaderTicker from './HeaderTicker';

export default HeaderTicker;